import { GtmService } from './services/gtm.service';
import { HttpExtendedService } from './services/http-extended.service';
import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute } from '@angular/router';
import { combineLatest, Subject } from 'rxjs';
import { filter, map, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  public isDealer = false;
  private onDestroy$ = new Subject<void>();
  constructor(
    private translate: TranslateService,
    private route: ActivatedRoute,
    private httpExtended: HttpExtendedService,
    private gtmService: GtmService
  ) {}

  ngOnInit(): void {
    combineLatest([this.route.params, this.route.queryParams])
      .pipe(
        takeUntil(this.onDestroy$),
        map(([params, queryParams]) => {
          return {
            params,
            queryParams: queryParams || null,
          };
        }),
        filter((results) => results.params?.lang !== undefined)
      )
      .subscribe((results) => {
        // set language
        this.translate.use(results.params.lang || 'en');
        // set country
        this.httpExtended.setCountryCode(results.params.country);

        // set dealer and campaign
        results.queryParams.dealer &&
          this.httpExtended.setDealer(results.queryParams.dealer);
        results.queryParams.campaign &&
          this.httpExtended.setCampaign(results.queryParams.campaign);

        // set isDealer
        if (this.httpExtended.getDealer()) {
          this.isDealer = true;
        }

        // get gtm id and load the script
        if (results.queryParams.gtm) {
          this.gtmService.loadGtm(results.queryParams.gtm);
        }
      });
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }
}
